import { AxiosError, AxiosRequestConfig } from 'axios';
import { restApi } from 'src/utilities/restApi';
import { ErrorResponse, SuccessResponse } from 'src/utilities/restApi/common/types/responses';
import {
  RequestSearchSupportRecipients,
  ResponseSearchSupportRecipients,
} from 'src/utilities/restApi/kanri/types/searchSupportRecipients';
import { getCommonHeaders } from 'src/utilities/restApi/utilities/getCommonHeader';

export const searchSupportRecipients = async (data: RequestSearchSupportRecipients, controller?: AbortController) => {
  const headers = { headers: await getCommonHeaders() };
  const config: AxiosRequestConfig = { ...headers, signal: controller?.signal };

  return new Promise<SuccessResponse<ResponseSearchSupportRecipients>>((resolve, reject) => {
    restApi()
      .post<SuccessResponse<ResponseSearchSupportRecipients>>('/search/support-recipients', data, config)
      .then((response) => {
        resolve(response.data!);
      })
      .catch((error: AxiosError<ErrorResponse>) => {
        return reject(error.response?.data);
      });
  });
};
